import {
  IOptionStoreListener,
  IOptionStoreSetter,
} from '../../store/OptionStore';
import { AmountChange, OrderDetails } from '../../types';
import { AmountChangeCallbacks } from '../CheckoutModules';
import TaxCalculation from './TaxCalculation';
import { TaxCalculationOptions } from './types';

const INITIATOR = 'TAXJAR';

class CheckoutTaxCalculator {
  private optionStoreListener: IOptionStoreListener;

  private optionStoreSetter: IOptionStoreSetter;

  private taxCalculationService: TaxCalculation;

  private callbacks: AmountChangeCallbacks;

  constructor(
    taxCalculationService: TaxCalculation,
    optionStoreListener: IOptionStoreListener,
    optionStoreSetter: IOptionStoreSetter,
    callbacks: AmountChangeCallbacks,
  ) {
    this.taxCalculationService = taxCalculationService;

    this.optionStoreListener = optionStoreListener;

    this.optionStoreSetter = optionStoreSetter;

    this.callbacks = callbacks;

    this.optionStoreListener.on('options.customerDetails', () => {
      this.getTaxOptionsAndCalculate();
    });

    this.optionStoreListener.on('options.businessDetails', () => {
      this.getTaxOptionsAndCalculate();
    });

    this.optionStoreListener.on('options.orderDetails', () => {
      this.getTaxOptionsAndCalculate();
    });

    // Calculate the tax now if possible
    this.getTaxOptionsAndCalculate();
  }

  public getTaxOptionsAndCalculate() {
    const customerDetails = this.optionStoreListener.getCustomerDetails();
    const businessDetails = this.optionStoreListener.getBusinessDetails();
    const orderDetailsWithInitiator = this.optionStoreListener.getOrderDetails();
    if (orderDetailsWithInitiator.orderDetailsInitiator === INITIATOR) {
      return;
    }
    if (
      customerDetails &&
      businessDetails &&
      orderDetailsWithInitiator.orderDetails
    ) {
      const taxCalculationOptions: TaxCalculationOptions = {
        customerDetails,
        businessDetails,
        orderDetails: orderDetailsWithInitiator.orderDetails,
      };
      this.calculateTax(taxCalculationOptions);
    }
  }

  public async calculateTax(options: TaxCalculationOptions) {
    try {
      this.callbacks.onAmountChanging?.(true);
      const taxResult = await this.taxCalculationService.calculateSalesTax(
        options,
      );
      this.callbacks.onAmountChange?.({
        ...taxResult,
      });
      this.updateOrderDetails(taxResult, options.orderDetails);
    } catch (e) {
      this.callbacks.onAmountChangeError?.(e);
    } finally {
      this.callbacks.onAmountChanging?.(false);
    }
  }

  public updateOrderDetails(
    taxResult: AmountChange,
    orderDetails: OrderDetails,
  ) {
    const updatedOrderDetails = {
      ...orderDetails,
      totalAmount: taxResult.totalAmount,
      totalTaxAmount: taxResult.totalTaxAmount,
    };
    this.optionStoreSetter.setOrderDetails(updatedOrderDetails, INITIATOR);
  }
}

export default CheckoutTaxCalculator;
